import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "London 2",
  "description": "",
  "published": "2007-09-19T00:00:00.000Z",
  "redirect_from": ["/blog/london-2/swizec/156"],
  "categories": "travel",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today started off with a bang as I got my first internet fix in a while and made the previous blog post. It continued with a whole new way of eating breakfast, at least for me, since I don't usually eat anything in the morning. Guess traveling changes that.`}</p>
    <p>{`I pranced around the streets having no clear direction or current location in mind when I was looking for a cash machine. Suddenly I found myself next to a sign saying "Camden Town Hall" ... luckily there was a cash machine right next to it and, as was hoped and expected, my Slovene plastic money works in London as well (later we found out it works for direct purchases as well). Walking around London is great.`}</p>
    <p>{`When I managed to navigate the tubes to what I'd deem the dead center of London I did my best to see as many sights as possible. There was Big Ben, Buckingham Palace and so on. The best of them all was, without a doubt, Westminster Abbey. The 7 quid admissoin fee feels awful at first, but it's utterly worth it when you realise just how big the place actually is, and it's bloody huge. What I thought would be more of a church turned out to be more of a burial site for the rich and important. There were early kings, Richard the Lionheart and such, very old graves too, some were about 700 years old even. Best was the Poet's corner with Chaucer's tomb and many other an important writer.`}</p>
    <p>{`Tower bridge and Tower of London were a bit of a let down because I got there too late to get in and the Eye of London was a complete ripoff at 15 quid, sure the view was pretty, but damn not for that price eh.`}</p>
    <p>{`It's also impressively difficult to find a place of tea buying and drinking when you don't know what to look for and just randomely blunder around trying to look like you know what you're doing. It also makes your legs very very sore in the evening ... damn walking.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      